import React from "react";

function CrossIcon({ ...props }) {
  return (
    <>
      <img
        src="https://cdn0.iconfinder.com/data/icons/user-interface-2063/24/UI_Essential_icon_expanded-02-1024.png"
        alt="cross"
        {...props}
      />
    </>
  );
}

export default CrossIcon;
